import React from "react";
import { withRouter } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { ContainerWrapper, NavStrip, HelmetTitle } from "../../../Components/Utils";
import Layout from "../../../Components/Layout";
import Navbar from "../Components/Navigation";

import TransBootcampFig from "../../../Images/Misc/Transnational-entrepreneurship-bootcamp_Aug30.jpg";
import CyberBootcampFig from "../../../Images/Misc/Cybersecurity-bootcamp_Aug30.jpg";

class ScalecampsSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tabIndex: 0 };
    this.setTabIndex = this.setTabIndex.bind(this);
  }
  componentDidMount() {
    this.setTabIndex();
  }
  setTabIndex() {
    return window.location.hash ? this.setState({ tabIndex: 1}) : '';
  }
  render() {
      const tablistClass = ['list-unstyled', 'scalecamps-tab__list'];
      const tabListItem = ['scalecamps-tab__list-item'];
      const tabcontentClass = ['scalecamps-tab__panel'];
      const figStyle = { width: '70%', height: 'auto', border: '1px solid #e9e6e6',}
      return (
      <div>
        <HelmetTitle title="Scalecamps" /> 
        <Layout 
        head={
          <React.Fragment>
            <Navbar />
            <NavStrip />
          </React.Fragment>
        } 
        body={
          <React.Fragment>
          <ContainerWrapper textAlign="justify" className="my-2">
            <h3 className="banner-item__header">Scalecamps</h3>
            <p>Strengthen growth plan; apply lessons learned from up-to-date literature and experience; and gain a foothold in a foreign country.
              Each scalecamp is unique and implemented to solve an important local, regional or global problem. A scalecamp can be delivered face-to-face, online or in hybrid mode.</p>
            <h3 className="banner-item__header--med mt-4 w-100 text-center">Scalecamps</h3>
            <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}>
              <TabList className={tablistClass}>
                <Tab className={tabListItem}>Transnational ventures</Tab>
                <Tab className={tabListItem}>Cybersecurity for entrepreneurs</Tab>
              </TabList>
              <TabPanel className={tabcontentClass}>
                <p>The goals of the Transnational Venture Scalecamp are to develop entrepreneurs’ capabilities to:</p>
                <ul>
                  <li>Compete in their home and foreign countries</li>
                  <li>Gain footholds in foreign countries</li>
                  <li>Collaborate globally to benefit locally</li>
                </ul>
                <p>The objectives of the Transnational Venture Scalecamp are to:</p>
                <ul>
                  <li>Increase the number of technology companies that go to foreign markets</li>
                  <li>Increase revenue for participating technology companies</li>
                  <li>Increase the size and diversity of the networks used to obtain resources, reputation and expertise</li>
                  <li>Reduce the gaps between what entrepreneurs know and what they need to know to grow their businesses across countries’ boundaries</li>
                </ul>
                <p>During the Transnational Venture Scalecamp, entrepreneurs</p>
                <ul>
                  <li>Gain a foothold in Ottawa</li>
                  <li>Prepare actionable growth plans</li>
                  <li>Receive substantive feedback on their growth plans</li>
                  <li>Interact with experienced instructors</li>
                  <li>Apply topic modeling, social media platforms and website assessment tools</li>
                  <li>Develop skills to apply principles of the GERS model to their ventures</li>
                  <li> Enhance their capabilities to grow their ventures, each to annual revenue of $1 million</li>
                  <li>Improve sales and communications skills</li>
                  <li>Make sense of their global and foreign environments</li>
                  <li>Access Global Projects</li>
                  <li>Increase their motivation and confidence</li>
                  <li>Earn certificates of completion</li>
                </ul>
                <div className="text-center">
                  <img 
                    src={TransBootcampFig} 
                    alt="Transnational Venture Scalecamp" 
                    title="Transnational Venture Scalecamp" 
                    style={figStyle}
                  />
                </div>
              </TabPanel>
              <TabPanel className={tabcontentClass}>
                <p>The goals of the Cybersecurity for Entrepreneurs Scalecamp are to develop entrepreneurs’ capabilities to:</p>
                <ul>
                  <li>Grow securely</li>
                  <li>Compete in new markets enabled by cybersecurity</li>
                </ul>
                <p>The objectives of the Cybersecurity for Entrepreneurs Scalecamp are to:</p>
                <ul>
                  <li>Increase the number of technology companies that grow securely</li>
                  <li>Increase revenue for participating technology companies through new opportunities enabled by cybersecurity infrastructures and behaviors</li>
                  <li>Increase the size and diversity of the networks used to obtain resources, reputation and expertise in cybersecurity</li>
                  <li>Enhance venture differentiation through integration of cybersecurity with its growth plan</li>
                  <li>Reduce the gaps between what entrepreneurs know and what they need to know to grow securely</li>
                </ul>
                <p>During the Cybersecurity for Entrepreneurs Scalecamp, entrepreneurs:</p>
                <ul>
                  <li>Prepare actionable plans to protect internet-connected systems, including hardware, software and data, from cyberattacks</li>
                  <li>Receive substantive feedback on their plans to prevent and respond to cyberattacks</li>
                  <li>Interact with experienced instructors</li>
                  <li>Apply a cross-section of high pedigree cybersecurity tools, techniques and guidelines</li>
                  <li>Apply GERS cybersecurity principles to enable growth and differentiate the venture from competition</li>
                  <li>Improve cybersecurity implementation and communications skills</li>
                  <li>Increase their cybersecurity motivation and confidence</li>
                  <li>Earn certificates of completion</li>
                </ul>
                <div className="text-center">
                  <img 
                    src={CyberBootcampFig} 
                    alt="Cybersecurity for Entrepreneurship Scalecamp" 
                    title="Cybersecurity for Entrepreneurship Scalecamp" 
                    style={figStyle}  
                  />
                </div>
              </TabPanel>
            </Tabs> 
            </ContainerWrapper>
          </React.Fragment>
        }
      />
    </div>
    );
  }
}

export default withRouter(ScalecampsSection)



// WEBPACK FOOTER //
// ./src/Pages/BannerItems/Pages/Scalecamp.js